import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {LoginService} from '../login.service';
import { Router,RouterModule} from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-gridview',
  templateUrl: './gridview.component.html',
  styleUrls: ['./gridview.component.css']
})
export class GridviewComponent implements ICellRendererAngularComp {
  public params: any;
  public gridApi:any;
  public gridColumnApi:any;
  constructor(public loginService:LoginService, public router: Router, public toastService:ToastrService) { }
      agInit(params: any): void {
          this.params = params;
          this.gridApi = params.api;
          this.gridColumnApi = params.columnApi;
      }
  
      refresh(): boolean {
          return false;
      }
      view(){
          if(this.params.data.doc_type != undefined){
            window.open(this.loginService.serverConst+"/getFile/"+this.params.data.path,"_blank");
          }
          else if(this.params.data.file_location != undefined){
            window.open(this.loginService.serverConst+"/getNotice"+this.params.data.file_location,"_blank");
          }
      }
      focus(event){
        if(event.keyCode == 9){
          this.gridApi.ensureIndexVisible(this.gridApi.paginationGetCurrentPage()*10);
          let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
          this.gridApi.ensureColumnVisible(firstCol);
          if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0) {
            return;
          }
          else if((this.gridApi.getFocusedCell().rowIndex >=9) && (this.gridApi.getFocusedCell().rowIndex)% ((this.gridApi.paginationGetCurrentPage()*10)+9) == 0){
            this.gridApi.paginationGoToNextPage();
          }
          else{
            event.preventDefault();
            this.gridApi.setFocusedCell((this.gridApi.getFocusedCell().rowIndex)+1, firstCol);
          }
        }
        else{
          return;
        }
      }
}



// WEBPACK FOOTER //
// ./src/app/gridview/gridview.component.ts